import React, { useEffect, useState, useRef, useCallback } from "react"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import Select from "react-select"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next" // Import scss
import { statusTypes } from "constants/common"
import "../../assets/scss/custom.scss"
import SpecialCreate from "./SpecialCreate"
import DeleteModal from "components/Common/DeleteModal"
import { map } from "lodash"
//redux
import { useDispatch } from "react-redux"
import {
  deleteNewSpecialDate,
  getExportSpecialDate,
  resetExportFileData,
} from "../../store/specialdates/actions"

const SpecialDateList = ({
  specialDates,
  isSpecialDateDeleted,
  getSpecialDates,
  setLoading,
  file,
}) => {
  const dispatch = useDispatch()
  const [isSpecialDateModal, setIsSpecialDateModal] = useState(false)
  const [speicalDateData, setSpeicalDateData] = useState()
  const [isDeleteModal, setIsDeleteModal] = useState(false)
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" })

  const onClickDelete = speicalDateData => {
    setSpeicalDateData({ speicalDateData, action: "Removed" })
    setIsDeleteModal(true)
  }

  const handleEditClick = speicalDateData => {
    setSpeicalDateData(speicalDateData)
    toggleModal()
  }
  const specialListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "Dates",
      dataField: "date",
      sort: true,
    },
    {
      text: "Title",
      dataField: "title",
      sort: true,
    },
    {
      text: "status",
      dataField: "status",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record.status === "Live" ? (
              <span className="badge bg-success">{record.status}</span>
            ) : (
              <span className="badge bg-danger">{record.status}</span>
            )}
          </>
        )
      },
    },
    {
      text: "Actions",
      dataField: "",
      isDummyField: true,
      editable: false,
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            <div className="d-flex gap-3">
              <Link
                style={{
                  opacity: checkStatus(record?.status) ? "0.4" : 5,
                  pointerEvents: checkStatus(record?.status) ? "none" : "auto",
                }}
                to="#"
                id="updateSpecialDate"
              >
                <i
                  className="mdi mdi-calendar-edit text-primary font-size-24"
                  id="edittooltip"
                  onClick={e => handleEditClick(record)}
                ></i>
                <UncontrolledTooltip placement="top" target="updateSpecialDate">
                  Update Special Date
                </UncontrolledTooltip>
              </Link>
              <Link
                style={{
                  opacity: checkStatus(record?.status) ? "0.4" : 5,
                  pointerEvents: checkStatus(record?.status) ? "none" : "auto",
                }}
                to="#"
                id="removeSpecialDate"
              >
                <i
                  className="text-danger mdi mdi-calendar-remove font-size-24"
                  id="edittooltip"
                  onClick={() => onClickDelete(record)}
                ></i>
                <UncontrolledTooltip placement="top" target="removeSpecialDate">
                  Remove Special Date
                </UncontrolledTooltip>
              </Link>
            </div>
          </>
        )
      },
    },
  ]

  const pageOptions = {
    sizePerPage: 5,
    totalSize: specialDates?.length || 1,
    custom: true,
    //onPageChange: setCurrentPage,
  }
  const defaultSorted = [
    {
      dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ]
  const keyField = "_id"

  const toggleModal = () => {
    setIsSpecialDateModal(!isSpecialDateModal)
  }
  const closeDeleteModal = useCallback(() => {
    setIsSpecialDateModal(false)
  }, [])

  const checkStatus = status => {
    if (status == statusTypes.Removed) {
      return true
    } else {
      return false
    }
  }

  const handleDeleteSpecialDate = () => {
    dispatch(deleteNewSpecialDate(speicalDateData.speicalDateData._id))
  }

  useEffect(() => {
    if (isSpecialDateDeleted) {
      dispatch(getSpecialDates())
      setIsDeleteModal(false)
    }
  }, [isSpecialDateDeleted])

  //Filter Options
  // const [isFilter , setIsFilter] = useState();

  const now = new Date().getUTCFullYear()
  const yearTypeOptions = Array(now - (now - 1))
    .fill("")
    .map((v, idx) => now - idx)
  let yearTypeOptionsData = map(yearTypeOptions, (key, i) => {
    return {
      value: `${key}`,
      label: `${key}`,
    }
  })

  const [filters, setFilters] = useState({ value: "All", label: "All" })
  const onChangeFilters = e => {
    setFilters(e)
    dispatch(getSpecialDates({ year: e.value }))
  }

  const setDownloadType = () => {
    const exportPayload = {
      // file_type: "csv",
      file_type: fileType.value,
    }
    dispatch(getExportSpecialDate(exportPayload))
  }

  const handleExport = fileData => {
    // const fileName = `user_post_pms_data` + new Date().getTime() + `.csv`
    const fileName =
      `special_dates_pms_data` +
      new Date().getTime() +
      `.${fileType.value.toLowerCase()}`
    // const downloadType = "application/vnd.ms-excel"
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? // ? "application/vnd.ms-excel"
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSelectType = e => {
    setFileType(e)
  }

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  useEffect(() => {
    if (file) {
      // Call to download file
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file])

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={isDeleteModal}
        onDeleteClick={handleDeleteSpecialDate}
        onCloseClick={() => setIsDeleteModal(false)}
      />
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              {/* <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={specialListColumns}
                data={specialDates}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return ( */}
                    <ToolkitProvider
                      keyField={keyField}
                      data={specialDates}
                      columns={specialListColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col md="3" sm="4">
                              <Select
                                placeholer="Select year"
                                name={"statusType"}
                                value={filters}
                                onChange={e => {
                                  onChangeFilters(e)
                                }}
                                options={yearTypeOptionsData}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col sm="auto ms-sm-auto">
                              <div className="text-sm-end d-flex gap-2">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={() => {
                                    setSpeicalDateData(null)
                                    toggleModal()
                                  }}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New Special Date
                                </Button>
                                {/* <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholder={"Select Type"}
                                    name={"File Type"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div> */}
                                {/* <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={() => setDownloadType()}
                                >
                                  <i className="bx bx-upload me-1" />
                                  Export
                                </Button> */}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  // {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  // ref={node}
                                  noDataIndication={emptyDataMessage}
                                />
                              </div>
                            </Col>
                          </Row>
                          {/* <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row> */}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  {/* )
                }}
              </PaginationProvider> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {isSpecialDateModal && (
        <SpecialCreate
          isOpen={isSpecialDateModal}
          toggle={toggleModal}
          specialDates={speicalDateData}
          onClose={closeDeleteModal}
          setSpeicalDateData={setSpeicalDateData}
          setLoading={setLoading}
        />
      )}
    </React.Fragment>
  )
}

SpecialDateList.propTypes = {
  specialDates: PropTypes.any,
  isSpecialDateDeleted: PropTypes.bool,
  getSpecialDates: PropTypes.any,
  setLoading: PropTypes.func,
  file: PropTypes.any,
}

export default withRouter(SpecialDateList)
